import { createContext, useContext, useReducer } from 'react';
import settingsReducer from '../reducer/settingsReducer';

const SettingsContext = createContext(null);
const SettingsDispatchContext = createContext(null);

export function SettingsProvider({ config, children }) {
  const [settings, dispatch] = useReducer(
    settingsReducer,
    {
			...config,
			isFormExpanded: false,
      expandedReply: null,
      deferedComment: null,
      isLoading: false
		}
  );

  return (
    <SettingsContext.Provider value={settings}>
      <SettingsDispatchContext.Provider value={dispatch}>
        {children}
      </SettingsDispatchContext.Provider>
    </SettingsContext.Provider>
  );
}

export function useSettings() {
  return useContext(SettingsContext);
}

export function useSettingsDispatch() {
  return useContext(SettingsDispatchContext);
}
